// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widget-admin{position:fixed;right:20px;bottom:20px;z-index:999;box-shadow:0 0 3px rgba(0,0,0,.1),0 0 10px rgba(0,0,0,.3);border-radius:50%;width:80px;height:80px;display:flex;align-items:center;justify-content:center;background:green}.widget-admin svg{width:60px;height:60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
